/*
 * @Author: wsx
 * @Date: 2022-01-15 15:11:52
 * @LastEditTime: 2022-01-24 10:31:15
 * @LastEditors: your name
 * @Description: request
 */

import moment from "moment";
import util from "@util/js";
import { toJSON, isJSON } from "./util";
import WebSocket from "../../websocket.js";

export const socket = new WebSocket({
  heartState: false, // 设置websocket是否使用心跳
  maxLinks: 2 // 设置websocket最大重连次数
});
let initStatus = false; // 初始化状态
const disableType = ["Show", "StopPreview", "Hide"]; // 没有初始化不可使用的类型
const onceHandlePools = {}; // 消息回调处理池（执行一次就销毁），格式：{'消息类型': {'消息ID': '处理函数'}}
export const keepHandlePools = {}; // 消息处理池，格式：{'消息类型': ['处理函数']}
export const socketInit = address => {
  socket.init(address);
};
/*
 * 消息请求
 * @param reqType     请求报文的消息类型
 * @param reqBody     请求报文的消息体
 * @param respType    响应报文的消息类型，空或null则不处理
 * @param respHandle  响应报文的处理函数，空或null则不处理
 */
export const request = (reqType, reqBody, respHandle) => {
  try {
    // 设置初始化状态
    if (reqType === "Init") {
      initStatus = true;
    }
    if (reqType === "UnInit") {
      initStatus = false;
    }
    // 没有初始化不可使用的类型
    if (!initStatus) {
      if (disableType.includes(reqType)) return;
    }
    const header = {
      msgId: new Date().getTime().toString(),
      msgType: reqType,
      sendTime: moment().format("YYYY-MM-DD HH:mm:ss")
    };

    const message = JSON.stringify({
      header: JSON.stringify(header),
      body: JSON.stringify(reqBody)
    });

    if (reqType && respHandle) {
      if (onceHandlePools[reqType] === undefined) {
        onceHandlePools[reqType] = {};
      }

      // 通过消息类型和消息ID来存放回调处理函数
      onceHandlePools[reqType][header.msgId] = respHandle;
    }

    // 通过websocket向视频客户端发送请求
    // console.log('videoClient=' + message)

    const openMode = util.analysisUrl("openMode");
    if (openMode && openMode === 1) {
      return;
    }
    socket.send(message);
  } catch (e) {
    console.error("请求视频客户端异常：" + reqType, e);
  }
};

/**
 * 消息响应
 */
export const response = event => {
  let message = null;

  try {
    // 解析消息
    message = toJSON(event.data);
    message.header = toJSON(message.header);
    message.body = toJSON(message.body);
    // console.log("视频客户端 <== 响应：", message);

    // 根据消息类型和消息ID获取处理函数
    const msgType = message.header.msgType;
    const msgId = message.header.msgId;
    if (message.body.returnValue && isJSON(message.body.returnValue)) {
      message.body.returnValue = toJSON(message.body.returnValue);
    }
    let pools = null;
    let handle = null;

    // 执行一次性的消息处理函数
    pools = onceHandlePools[msgType];
    if (pools) {
      handle = pools[msgId];

      if (handle) {
        // eslint-disable-next-line eqeqeq
        if (message.body.code == 200) {
          // console.error(JSON.stringify(message.body))
          handle.reject(message.body);
        }
        handle.resolve(message.body);
        delete pools[msgId]; // 调用处理函数后删除该函数（每个请求对应的回调函数只处理一次）
      }
    }

    // 执行消息处理函数
    pools = keepHandlePools[msgType];
    if (pools) {
      pools.forEach(handle => {
        try {
          handle(message);
        } catch (e) {
          console.error("执行消息处理时异常：", e);
        }
      });
    }
  } catch (e) {
    console.error("处理视频客户端响应消息异常：", e);
  }
};

/**
 * 注册消息监听
 * @param {*} msgType 消息类型
 * @param {*} callback 处理函数
 */
export const onMsgEvent = (msgType, callback) => {
  if (keepHandlePools[msgType] === undefined) {
    keepHandlePools[msgType] = [callback];
  } else {
    keepHandlePools[msgType].push(callback);
  }
};

/**
 * 注销消息监听
 * @param {*} msgType 消息类型
 * @param {*} callback 处理函数
 */
export const offMsgEvent = (msgType, callback) => {
  const pools = keepHandlePools[msgType];
  if (pools !== undefined) {
    if (callback) {
      const index = pools.indexOf(callback);
      if (index > -1) {
        pools.splice(index, 1);
      }
    } else {
      pools.splice(0, pools.length - 1);
    }
  }
};